export default {
  forgotPassword: "Forgot Password",
  emailAddress: "Email",
  signIn: "Sign in",
  resetPassword: "Reset Password",
  justRemembered: "Remembered your password?",
};
